import { render } from "./EmotionalAnalysis.vue?vue&type=template&id=64f91244&scoped=true"
import script from "./EmotionalAnalysis.vue?vue&type=script&lang=js"
export * from "./EmotionalAnalysis.vue?vue&type=script&lang=js"

import "./EmotionalAnalysis.vue?vue&type=style&index=0&id=64f91244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f91244"]])

export default __exports__